const accordions = function () {
  return {
    item: '',
    toggleTab(tab) {
      if (this.item === tab) {
        this.item = '';
      } else {
        this.item = tab;
      }
    }
  }
}

document.addEventListener('alpine:init', () => {
Alpine.data('accordions', accordions);
});